import { Controller } from "@hotwired/stimulus";
const TITLE_STATEMENT = ".group-title-statement";
const CONTENT = ".group-response-options";
const ICON_COLLAPSE = ".group-icon-collapse";
const ICON_EXPAND = ".group-icon-expand";
export default class extends Controller {
  connect() {
    this.titleStatement = this.element.querySelector(TITLE_STATEMENT);
    this.titleInput = this.findTitleInput();
    if (this.titleInput) {
      this.boundUpdateLabel = this.updateLabel.bind(this);
      this.titleInput.addEventListener("input", this.boundUpdateLabel);
      this.titleInput.addEventListener("change", this.boundUpdateLabel);
    }
    this.updateLabel();
  }
  disconnect() {
    if (this.titleInput && this.boundUpdateLabel) {
      this.titleInput.removeEventListener("input", this.boundUpdateLabel);
      this.titleInput.removeEventListener("change", this.boundUpdateLabel);
    }
  }
  toggleCollapse(event) {
    var _a, _b, _c;
    event.preventDefault();
    const button = event.currentTarget;
    const willExpand = button.getAttribute("aria-expanded") === "false";
    button.setAttribute("aria-expanded", willExpand.toString());
    (_a = this.element.querySelector(CONTENT)) == null ? void 0 : _a.classList.toggle("hidden", !willExpand);
    (_b = button.querySelector(ICON_COLLAPSE)) == null ? void 0 : _b.classList.toggle("hidden", !willExpand);
    (_c = button.querySelector(ICON_EXPAND)) == null ? void 0 : _c.classList.toggle("hidden", willExpand);
  }
  updateLabel() {
    if (!this.titleStatement) {
      return;
    }
    const maxLength = parseInt(this.titleStatement.dataset.maxLength, 10) || 50;
    const omission = this.titleStatement.dataset.omission || "...";
    const placeholder = this.titleStatement.dataset.placeholder || "";
    let text = this.titleInput && this.titleInput.value || placeholder;
    if (text.length > maxLength) {
      text = text.substring(0, maxLength - omission.length) + omission;
    }
    this.titleStatement.textContent = text;
  }
  findTitleInput() {
    var _a;
    const locale = (_a = this.titleStatement) == null ? void 0 : _a.dataset.locale;
    if (!locale) {
      return null;
    }
    return this.element.querySelector(`input[name$='[title_${locale}]']`);
  }
}
